// extracted by mini-css-extract-plugin
module.exports = {"dark":"Popup_dark__7-8pJ","Popup_wrapper":"Popup_Popup_wrapper__3GXVV","Popup":"Popup_Popup__2Um3d","Popup_close":"Popup_Popup_close__2CCBh","warning":"Popup_warning__1Shz0"};